import { createFileRoute } from '@tanstack/react-router';
import AuthGuard from '@/components/auth-guard';
import { ChapterReader } from '@/features/reader/components/ChapterReader';

export const Route = createFileRoute('/read/$novelId/$chapterId')({
  component: ChapterReaderPage,
});

function ChapterReaderPage() {
  const { novelId, chapterId } = Route.useParams();

  return (
    <AuthGuard>
      <ChapterReader novelId={novelId} chapterId={chapterId} />
    </AuthGuard>
  );
}
